export default function initBrandModelFilter() {
  const brandSel = document.getElementById('brand');
  const modelSel = document.getElementById('model');
  if (!brandSel || !modelSel) return;

  const allOptions = Array.from(modelSel.querySelectorAll('option')).filter((o) => o.value !== '');
  const optgroups  = Array.from(modelSel.querySelectorAll('optgroup'));

  const filterModels = () => {
    const bid = brandSel.selectedOptions[0]?.getAttribute('data-id') || '';

    allOptions.forEach((o) => { o.hidden = true; });
    optgroups.forEach((g)  => { g.hidden = true; });

    if (!bid) {
      modelSel.disabled = true;
      modelSel.value    = '';
      return;
    }

    let visibleCount = 0;
    allOptions.forEach((o) => {
      if (o.getAttribute('data-brand') === bid) { o.hidden = false; visibleCount++; }
    });
    optgroups.forEach((g) => {
      if (g.getAttribute('data-brand') === bid) g.hidden = false;
    });

    modelSel.disabled = visibleCount === 0;
    modelSel.value    = '';
  };

  brandSel.addEventListener('change', filterModels);
}
